import { createDebug } from './core.debug'

export default createDebug('core')
